import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/* PIE CHART KOJI SE KORISTI ZA STATISTIKU POLA */
const GenderPieChart = ({ data, valueKey, colors, showTitle }) => {
  const { t } = useTranslation();
  const pieData = data.map((item) => ({
    name: item.Pol === 'm' ? t('statistic.male') : t('statistic.female'),
    value: parseInt(item[valueKey], 10) || 0
  }));

  return (
    <Box height={400}>
      {showTitle && (
        <Typography
          variant="h6"
          gutterBottom
          sx={{ color: '#2596be', fontWeight: 'bold' }}
        >
          {t('adminDashboard.gender_distribution')}
        </Typography>
      )}
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={pieData}
            cx="50%"
            cy="50%"
            label={({ name, value }) => `${name}: ${value}`}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
          >
            {pieData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={colors[index % colors.length]}
                stroke="#fff"
                strokeWidth={2}
              />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default GenderPieChart;
